
import {Component, Prop, Vue} from 'vue-property-decorator';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {email, required} from 'vee-validate/dist/rules';
import {ExtendedDataLayer} from "default/js/shared/helpers/extended-datalayer";

extend('required', required);
extend('email', email);

@Component({
  name: 'footer-subscribe',
  components: {
    ValidationProvider,
    ValidationObserver
  }
})

export default class extends Vue {
  @Prop({required: true}) privacyLabel: string;
  @Prop({required: true}) privacyUrl: string;

  private email: string = '';
  private message: string = '';
  private success: string | null = null;
  private isLoading: boolean = false;
  private privacyAccept: boolean = false;

  private acceptError: string ='';

  private async doSubscribe() {
    this.isLoading = true;

    if(!this.privacyAccept){
      this.acceptError = this.$t('Privacy checkbox is required') as string
    } else{
      this.acceptError = '';
    }
    try {
      const {data} = await this.$mageClient.post(`/api/newsletter/subscribe`, {email: this.email});
      this.message = data.message;
      this.success = data.success;
    } catch (e) {
      // this.email = '';
    } finally {
      if(this.success) {
        new ExtendedDataLayer().addNewsLetterSignUp();
      }
      this.isLoading = false;
      setTimeout(() => {
        this.message = '';
        this.success = null;
      }, 4000);
    }
  }
}
